// extracted by mini-css-extract-plugin
export var customTooltip = "MobileDataGrid-module--custom-tooltip--ZsiKr";
export var dot = "MobileDataGrid-module--dot--nfBWV";
export var padding2 = "MobileDataGrid-module--padding-2--f9Yxa";
export var paddingLeft2 = "MobileDataGrid-module--padding-left-2--rR0hK";
export var shield = "MobileDataGrid-module--shield--jRes6";